
export default "/assets/stack-micro.ccb5ddb7.svg"